module.exports = __webpack_public_path__ + "static/media/npr.58f83a40.svg";